import React, { useEffect, useCallback, useState, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { deepOrange, red } from '@material-ui/core/colors';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Card,
  Grid, CardContent, makeStyles,
  Divider
} from '@material-ui/core';
import './ManagePresentationModal.scss';
// import CheckboxList from './CheckBoxListData.js';
import { uploadContentService } from '../../../services';
import CustomizedSelects from '../Dropdowns';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

});

const useStyles = makeStyles((theme) => ({
  containers: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardcontent: {
    padding: 40,
  },

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 350,
    marginTop: 15,
    backgroundColor: '#FFFFFF',
    padding: 5,

  },
  avatar: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',

  },
  buttonMarkAll: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    width: 150,
    borderRadius: 0,
  },

  avatar1: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    maxWidth: '40px', maxHeight: '50px', minWidth: '30px', minHeight: '30px',
  },
  avatar2: {
    backgroundColor: deepOrange[800],
  },
  textColorChanger: {
    color: deepOrange[400],
  },
  buttonColor: {
    maxWidth: 150, maxHeight: 35, minWidth: 150, minHeight: 35,
    backgroundColor: deepOrange[500],
  },
  errors: {
    color: '#FF4949',
    fontSize: '15px'
  },
  '@global': {
    // You should target [class*='MuiButton-root'] instead if you nest themes.
    '.MuiInputBase-input': {
      color: 'white'
    },
    '.MuiSelect-select:not([multiple]) option, .MuiSelect-select:not([multiple]) optgroup': {
      backgroundColor: '#434343'
    }
  }
})
);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),

  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",

  },
}))(MuiDialogActions);


export default function ManagePresentationModal({ modalShow, modalState,
  modalType, id, editInfo }) {
  const classes = useStyles();
  const fref = useRef();
  const [open, setOpen] = useState(modalShow);
  const { user } = useSelector(state => state.userAuthentication);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  const connectorTypeList = [
    'HDMI',
    'VGA'
  ];

  const videoModeList = [
    '1920x1080x60p',
    '1920x1080x50p',
    '1920x1080x29.97p',
    '1920x1080x60i',
    '1920x1080x59.94i',
    '1920x1080x50i',
  ];

  const monitorOrientationList = [
    'Landscape',
    'Portrait'
  ]

  const [presentationInputs, setPresentationInputs] = useState({
    presentationName: '',
    overscanValue: 'Overscan',
    connectorType: 'HDMI',
    videoMode: '1920x1080x60p',
    monitorOrientation: 'Landscape'
  });

  if (modalType === 'edit') {
    if (!isLoaded) {
      if (editInfo.screenSettings === null)
        setPresentationInputs({
          presentationName: editInfo.name,
          overscanValue: 'Overscan',
          connectorType: 'HDMI',
          videoMode: '1920x1080x60p',
          monitorOrientation: 'Landscape'
        })
      else
        setPresentationInputs({
          presentationName: editInfo.name,
          overscanValue: editInfo.screenSettings.overscan,
          connectorType: editInfo.screenSettings.connector,
          videoMode: editInfo.screenSettings.videoMode,
          monitorOrientation: editInfo.screenSettings.orientation
        })

      setIsLoaded(true);
    }

  }

  const {
    presentationName,
    overscanValue,
    connectorType,
    videoMode,
    monitorOrientation
  } = presentationInputs;

  const handleClose = () => {
    modalState(false);
  };

  const savePresentation = () => {
    if (presentationName === '') {
      setErrorMessage('Presentation name is required')
      return;
    }
    if (modalType === 'add')
      uploadContentService.addPresentation(user, presentationInputs);
    else
      uploadContentService.updatePresentation(user, presentationInputs, id);
  }

  const handleChangePresentationName = (e) => {
    setPresentationInputs({
      presentationName: e.target.value,
      overscanValue: overscanValue,
      connectorType: connectorType,
      videoMode: videoMode,
      monitorOrientation: monitorOrientation
    })
  }

  const handleChangeConnectorType = (e) => {
    setPresentationInputs({
      presentationName: presentationName,
      overscanValue: overscanValue,
      connectorType: e.target.value,
      videoMode: videoMode,
      monitorOrientation: monitorOrientation
    })
  }

  const handleChangeVideoMode = (e) => {
    setPresentationInputs({
      presentationName: presentationName,
      overscanValue: overscanValue,
      connectorType: connectorType,
      videoMode: e.target.value,
      monitorOrientation: monitorOrientation
    })
  }

  const handleChangeMonitorOrientation = (e) => {
    setPresentationInputs({
      presentationName: presentationName,
      overscanValue: overscanValue,
      connectorType: connectorType,
      videoMode: videoMode,
      monitorOrientation: e.target.value
    })
  }

  const handleChangeOverscanValue = (e) => {
    setPresentationInputs({
      presentationName: presentationName,
      overscanValue: e.target.value,
      connectorType: connectorType,
      videoMode: videoMode,
      monitorOrientation: monitorOrientation
    })
  }

  return (
    <div >
      <Dialog TransitionComponent={Transition} disableBackdropClick={true}
        maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle className="dialog-header" id="customized-dialog-title" onClose={handleClose}>
          {modalType === 'add' ? 'Create Presentation' : 'Edit Presentation'}
        </DialogTitle>
        <DialogContent dividers className="dialog-content"  >
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <Grid lg={12} md={12} xs={12} >
              <Card className="card-main" justify="center" cot   >
                <CardContent style={{ overflow: 'auto' }}>
                  <Grid container item justify="center" lg={12} xs={12} md={12}>
                    <form noValidate autoComplete="off" >
                      <label className={classes.presentaionLabel} > Name:
                        <TextField
                          className="credentials-input-field"
                          type="text"
                          id="presentationName"
                          name="presentationName"
                          placeholder=""
                          fullWidth
                          margin="normal"
                          autoFocus
                          value={presentationName}
                          onChange={handleChangePresentationName}
                        />
                      </label>
                    </form>
                  </Grid>
                  {
                    errorMessage === '' ? '' :
                      <span className={classes.errors}>{errorMessage}</span>
                  }
                  <Grid container item style={{ marginTop: '10px' }}>
                    <label className={classes.presentaionLabel} > Connector Type:
                      <CustomizedSelects items={connectorTypeList} value={connectorType}
                        handleChange={handleChangeConnectorType} />
                    </label>
                  </Grid>
                  <Grid container item style={{ marginTop: '10px' }}>
                    <label className={classes.presentaionLabel} > Video Mode:
                      <CustomizedSelects items={videoModeList} value={videoMode}
                        handleChange={handleChangeVideoMode} />
                    </label>
                  </Grid>
                  <Grid container item style={{ marginTop: '10px' }}>
                    <label className={classes.presentaionLabel} > Monitor Orientation:
                      <CustomizedSelects items={monitorOrientationList} value={monitorOrientation}
                        handleChange={handleChangeMonitorOrientation} />
                    </label>
                  </Grid>
                  <Grid container item style={{ marginTop: '10px' }}>
                    <label className={classes.presentaionLabel} > Monitor overscan:
                      <RadioGroup aria-label="overscan" name="overscan1" value={overscanValue} onChange={handleChangeOverscanValue}>
                        <FormControlLabel value="Overscan" control={<Radio />} label="No overscan - use full screen" />
                        <FormControlLabel value="OverscanActionSafeArea" control={<Radio />} label="Overscan - action safe area" />
                        <FormControlLabel value="OverscanTitleSafeArea" control={<Radio />} label="Overscan - title safe area" />
                      </RadioGroup>
                    </label>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classname="dialog-action">
          <Button onClick={handleClose} variant="contained" color="default">CANCEL</Button>
          <Button variant="contained" onClick={savePresentation} className={classes.buttonColor}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}